import { render, staticRenderFns } from "./companyBusiness.vue?vue&type=template&id=ec11c9a6&scoped=true"
import script from "./companyBusiness.vue?vue&type=script&lang=js"
export * from "./companyBusiness.vue?vue&type=script&lang=js"
import style0 from "./companyBusiness.vue?vue&type=style&index=0&id=ec11c9a6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec11c9a6",
  null
  
)

export default component.exports